/* hover menu */
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

/* accordion */
var collContents = document.getElementsByClassName("accordion-da-content");
var coll = document.getElementsByClassName("accordion-da");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    // this.classList.toggle("active");
    var n = 0;
    if (this.classList.contains("active")) {
      for (n = 0; n < coll.length; n++) {
        coll[n].classList.remove("active");
      }
    } else {
      for (n = 0; n < coll.length; n++) {
        coll[n].classList.remove("active");
      }

      this.classList.toggle("active");
    }
  });
}
/* end accordion */

var backToTop = document.getElementById("BackToTop");
if (backToTop) {
  backToTop.addEventListener("click", () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  });
}

// alert(Shopify.locale)

if (Shopify.locale.toLowerCase() == "de") {
  // callback for multiple players
  window.onVidyardAPI = (vidyardEmbed) => {
    // var players = VidyardV4.api.getPlayersByUUID("4M2kpUiyCtKRnP34HBygRw");
    //players[0].play();
    vidyardEmbed.api.addReadyListener((_, player) => {
      // console.log("player ready:", player.ready());
      // console.log(player.uuid);
      // put your code here
      // console.log(Shopify.locale);
      // if (Shopify.locale == "de") {
      // debugger
      player.enableCaption("Deutsch", "de");
      // }
    }); // because we're looking for multiple players, we have no UUID specified here
  };
}
